import { useEffect, useState } from "react";
import DefaultCard from "../../Components/Ui/Card/DefaultCard";
import DividerCard from "../../Components/Ui/Card/DividerCard";
import CustomButton from "../../Components/Ui/CustomButton";
import ToggleButton from "../../Components/Ui/ToggleButton/ToggleButton";
import { useScheinContext } from "../../Store/schein-context";

const Summary: React.FC<{ onButtonClick: (page: string) => void }> = ({
  onButtonClick,
}) => {
  const {
    selectedProducts,
    day,
    startTime,
    endTime,
    fahrtBerechnen,
    comment,
    startOrt,
    zielOrt,
    distanz,
    selectedCustomer,
  } = useScheinContext();

  // Funktion zur Zeitformatierung
  const formatTime = (date: Date) =>
    `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

  const [sum, setSum] = useState(0);

  const [showPrices, setShowPrices] = useState(false);

  useEffect(() => {
    let temp: number = 0;
    selectedProducts.forEach((prods) => {
      temp = temp + prods.menge * prods.vk;
    });
    setSum(temp * 1.19);
  }, [selectedCustomer, selectedProducts]);

  return (
    <main className="w-full min-h-screen flex flex-col items-center px-4 sm:px-6 md:px-8 lg:px-10">
      <h2 className="text-blue_royal text-2xl sm:text-3xl font-semibold my-5 p-5 text-center">
        Zusammenfassung
      </h2>

      {/* Grid-Layout für Inhalt */}
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Linke Spalte: Informationen */}
        <div className="flex flex-col flex-grow space-y-3">
          <DividerCard heading="Information" isSingleColumn>
            <DefaultCard
              className="flex-1"
              title="Kunde"
              text={selectedCustomer.Kunde}
            />

            <DefaultCard
              className="flex-1"
              title="Arbeitszeit"
              text={`Am ${day.toLocaleDateString()} von ${formatTime(
                startTime
              )} bis ${formatTime(endTime)}`}
            />
            <DefaultCard
              className="flex-1"
              title="Arbeitsweg"
              text={`Von ${startOrt} bis ${zielOrt} (Entfernung ${distanz} km)`}
              useConditional
              conditional={fahrtBerechnen}
              conditionalTextTrue=" (wird berechnet)"
              conditionalTextFalse=" (wird nicht berechnet)"
            />
          </DividerCard>
          {/* Warenkorb */}
          <DividerCard heading="Warenkorb" isSingleColumn>
            <div className="flex flex-col">
              <div className="p-5 bg-white border border-gray-200 rounded-lg shadow-md">
                <ToggleButton
                  isChecked={showPrices}
                  onToggle={() => {
                    setShowPrices(!showPrices);
                  }}
                  className="flex-shrink-0"
                />
                {/* <h2 className="text-blue_royal text-xl font-semibold">
                Warenkorb
              </h2> */}
                {selectedProducts.length === 0 ? (
                  <p className="mt-2 text-gray-500">
                    Keine Produkte ausgewählt
                  </p>
                ) : (
                  <ul className="mt-3 space-y-2">
                    {selectedProducts.map((product) => (
                      <li
                        key={product.id}
                        className="bg-gray-100 rounded-lg p-3 shadow-sm flex flex-col sm:flex-row sm:justify-between"
                      >
                        <p className="font-semibold">
                          {product.menge}x | {product.artikel} (
                          {product.provisionsnehmer}){" "}
                          {showPrices ? <>~ {product.vk} €/Stk</> : <></>}
                        </p>
                        {product.kommentar && (
                          <p className="text-sm whitespace-pre-line text-gray-700 sm:text-right">
                            {product.kommentar}
                          </p>
                        )}
                      </li>
                    ))}
                    {showPrices ? (
                      <>
                        <div className="w-full h-[2px] bg-gray-500" />
                        <li>
                          <div className="flex justify-between">
                            <p className="flex justify-left items-start font-bold">
                              Gesamtsumme (inkl. MwSt.):
                            </p>
                            <p className="flex justify-right items-end font-bold">
                              {sum.toFixed(2)} €
                            </p>
                          </div>
                        </li>
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </DividerCard>
        </div>
        <div className="flex-none">
          <DividerCard heading="Grund des Technikereinsatzes" isSingleColumn>
            <DefaultCard text={comment} />
          </DividerCard>
        </div>
      </div>

      {/* Buttons für Navigation */}
      <div className="w-full grid grid-cols-2 gap-4 mt-10">
        <CustomButton
          className="w-full"
          theme="gray"
          onClick={() => onButtonClick("leistung")}
        >
          Zurück
        </CustomButton>

        <CustomButton
          className="w-full"
          theme="navy"
          onClick={() => onButtonClick("checkpage")}
        >
          Weiter
        </CustomButton>
      </div>
    </main>
  );
};

export default Summary;
